import { loadStripe, Stripe } from '@stripe/stripe-js'

/**
 * Lazily load and memoise the Stripe.js instance.
 *
 * The publishable key can come from either the `REACT_APP_STRIPE_PUBLISHABLE_KEY`
 * build-time env var or, as a fallback, from the backend (the `createSetupIntent`
 * mutation returns it). We memoise per key so Stripe.js is only downloaded once.
 */
const stripePromises: Record<string, Promise<Stripe | null>> = {}

export const ENV_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''

export const getStripe = (publishableKey?: string | null): Promise<Stripe | null> | null => {
  const key = publishableKey || ENV_STRIPE_PUBLISHABLE_KEY
  if (!key) return null

  if (!stripePromises[key]) {
    stripePromises[key] = loadStripe(key)
  }
  return stripePromises[key]
}
